import { t } from 'i18next';
import _ from 'lodash';
import moment from 'moment';
import { getSeasonBySlug, KEYSTONE_BRACKETS_BY_ID, MPLUS_TEAM_FEATURED_BRACKETS } from '../../../../../shared/enums';
import { namedRoutes, resolveRoutePath } from '../../../bundles/routes';
import TeamRankingsWidget from '../../../team/containers/teamRankingsWidget';
import { Link } from '../../../../../../../shared/frontend/components/link';
import WowIcon from '../../../../../../../shared/frontend/scripts/wow/components/WowIcon';
import { SeasonCountdownPane } from './countdownPane';
import apiService from '../../../services/apiService';
import { actions as TeamActions } from '../../../team/modules';
import { Col } from '../../../../../../../shared/frontend/components/grid/Col';
import { Row } from '../../../../../../../shared/frontend/components/grid/Row';

export type TMythicPlusTeamsPaneProps = {
  enabled: boolean;
  seasonSlug: string;
  region: string;
};

export function MythicPlusTeamsPane(props: TMythicPlusTeamsPaneProps) {
  if (!props.enabled) {
    return null;
  }

  const season = getSeasonBySlug(props.seasonSlug);
  if (!season) {
    return null;
  }

  const isSeasonActive = moment.utc() >= season.starts.us;

  const countdown = !isSeasonActive ? <SeasonCountdownPane season={season} index={3} /> : null;

  return (
    <div className="rio-mplus-teams-pane">
      <div className="slds-m-bottom--small slds-m-top--large rio-m-top-mobi--x-small">
        <h2 className="rio-text-title--caps text-raiderio">
          <span className="rio-text-title--caps text-raiderio">{t('frontpage:top-mplus-teams')}</span>
          <span className="slds-m-left--small slds-text-title--caps text-white">
            {t(`seasons:${season.slug}.name`)} {season.affix && <>({t(`seasons:${season.slug}.affix`)})</>}
          </span>
        </h2>
      </div>

      {isSeasonActive ? (
        <Row gutter={['xx-small', 'xx-small']}>
          {MPLUS_TEAM_FEATURED_BRACKETS.map((bracketId: number, index: number) => (
            <Col size={12} sm={index === 0 ? 12 : 6} md={4} grow className="slds-is-relative" key={bracketId}>
              <TeamRankingsWidget
                title={
                  <div className="slds-text-align--center slds-text-heading--small">
                    <WowIcon icon={KEYSTONE_BRACKETS_BY_ID[bracketId]!.icon} size="x-small" />
                    &nbsp; {t(`frontpage:top-teams.${KEYSTONE_BRACKETS_BY_ID[bracketId]!.slug}`)}
                  </div>
                }
                season={season.slug}
                region={props.region}
                eventId={1}
                page={0}
                pageSize={5}
                bracket={KEYSTONE_BRACKETS_BY_ID[bracketId]!.slug}
                instanceId={`frontpage:team:${props.region}:${bracketId}`}
                footer={
                  <tfoot>
                    <tr>
                      <td colSpan={3} className="slds-text-align--center slds-text-body--small">
                        <Link
                          className="rio-realm-link--muted"
                          to={resolveRoutePath(namedRoutes.TeamLeaderboardPage, {
                            season: season.slug,
                            region: 'world',
                            bracket: KEYSTONE_BRACKETS_BY_ID[bracketId]!.slug,
                            week: 'all',
                            faction: 'all'
                          })}
                        >
                          {t('common:leaderboard.view-leaderboard-prompt')}
                        </Link>
                      </td>
                    </tr>
                  </tfoot>
                }
              />
            </Col>
          ))}
        </Row>
      ) : (
        countdown
      )}
    </div>
  );
}

(MythicPlusTeamsPane as any).preloadComponentActions = async (props: TMythicPlusTeamsPaneProps, params: any) => {
  if (!props.enabled) {
    return Promise.resolve([]);
  }

  return _.flatten(
    await Promise.all(
      MPLUS_TEAM_FEATURED_BRACKETS.map(
        (bracketId: number) =>
          new Promise((resolve: any, reject: any) => {
            const loadParams: any = {
              region: props.region,
              season: props.seasonSlug,
              bracket: KEYSTONE_BRACKETS_BY_ID[bracketId]!.slug,
              page: 0,
              pageSize: 5
            };

            const key = `frontpage:team:${props.region}:${bracketId}`;

            apiService.getTeamLeaderboard(loadParams, (err: any, data: any) => {
              if (err) {
                reject(err);
              } else {
                resolve([
                  TeamActions.setViewTeamLeaderboardSucceeded(key, {
                    ...loadParams,
                    results: data.viewTeamLeaderboardApi
                  })
                ]);
              }
            });
          })
      )
    )
  );
};
